<template>
  <div class="content">
    <div class="Tabs">

      <b-tabs card v-model="tabIndex">

        <b-tab :title="lang.tab_QuickView" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 0">

          <div v-if="selectedPartBomRow.revisionId == undefined">
            <p>{{lang.infotext_1}}</p>
          </div>
          <div v-if="selectedPartBomRow.revisionId == 0">
            <p>{{lang.infotext_2}}</p>
          </div>
          <QuickViewBomPartComponent
            v-if="(selectedPartBomRow.revisionId != undefined)&&(selectedPartBomRow.revisionId != 0)" :source="'false'"
            :lang="lang.QuickView"></QuickViewBomPartComponent>

        </b-tab>


        <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_WhereUse" :title-link-class="textColors"
          :title-item-class="textColors" :active="tabIndex == 1">

          <div v-if="selectedPartBomRow.revisionId == undefined">
            <p>{{lang.infotext_3}}</p>
          </div>
          <WhereUseTableComponent :parent="'bom'" v-if="selectedPartBomRow.revisionId != undefined"
            :lang="lang.WhereUse"></WhereUseTableComponent>
          <br><br>
          <WhereLibUsedComponent :parent="'bom'"
            v-if="selectedPartBomRow.revisionId != undefined && selectedPartBomRow.libraries" :lang="lang.WhereLibUsed">
          </WhereLibUsedComponent>
          <br><br>
          <WhatIsIncludedComponent :parent="'bom'"
            v-if="selectedPartBomRow.revisionId != undefined && selectedPartBomRow.libraries && (selectedPartBomRow.type == 'footprint' || selectedPartBomRow.type == 'padstack')"
            :lang="lang.WhatIsIncluded"></WhatIsIncludedComponent>

        </b-tab>
        <b-tab :title="lang.tab_Alternatives" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 2">

          <div v-if="selectedPartBomRow.revisionId == undefined">
            <p>{{lang.infotext_4}}</p>
          </div>
          <div v-if="selectedPartBomRow.revisionId != undefined">
            <AlternativesTableComponent v-show="!isAlternativeSelected" v-if="selectedPartBomRow.partId != undefined"
              :lang="lang.Alternatives" :parent="'bom'"></AlternativesTableComponent>
            <div v-if="isAlternativeSelected">
              <AlternativeDetailsComponent :lang="lang.AlternativeDetails"></AlternativeDetailsComponent>
            </div>
          </div>
        </b-tab>
        <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_IPCImage" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 3">

          <IpcViewerComponent name="Parts" :lang="lang.IPCViewer" :zooming="true"></IpcViewerComponent>

        </b-tab>
      </b-tabs>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QuickViewBomPartComponent from '@/components/shared/QuickViewBomPartComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import AlternativesTableComponent from '@/components/shared/AlternativesTableComponent'
import AlternativeDetailsComponent from '@/components/shared/AlternativeDetailsComponent'
import IpcViewerComponent from '@/components/shared/IpcViewerComponent'
import WhereLibUsedComponent from '@/components/shared/WhereLibUsedComponent'
import WhatIsIncludedComponent from '@/components/shared/WhatIsIncludedComponent'

export default {
  name: "Content",
  components: {
    QuickViewBomPartComponent,
    WhereUseTableComponent,
    AlternativesTableComponent,
    AlternativeDetailsComponent,
    IpcViewerComponent,
    WhereLibUsedComponent,
    WhatIsIncludedComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: null,
      width:"",
      height:""

    }
  },
  computed: {
    ...mapGetters({
      selectedPartBomRow: 'selectedPartBomRow',
      appConf: 'appConf',
    }),
    isAlternativeSelected(){
      return this.$store.getters.selectedAlternative.distributorPartId != undefined;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {
    this.getTabIndex();
  },
  
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################

      
    },
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }

    },
  }
}
</script>

<style lang="scss">

  .Tabs{

    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }
    .container{
      margin-left: 0px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectBom/Right/Content/Content.vue